import React from 'react';
import Header from '../../Header';
import MemberDirecotry from './MemberDirecotry';

const MainMemberDirectoryPage = () => {
  return (
    <div>
      <Header />
      <MemberDirecotry/>
    </div>
  );
};

export default MainMemberDirectoryPage;